// extracted by mini-css-extract-plugin
export default {"GetTheAppContent":"GetTheAppContent_GetTheAppContent__PMlpt"};